import Contract from './index'

import TaskData from './TaskData'
import UserData from './UserData'
import Statistics from './Statistics'

export default {
  path: '/home/activity/record',
  redirect: '/home/activity/record/taskData',
  component: Contract,
  meta: { titie: '任务记录' },
  children: [
    {
      path: '/home/activity/record/taskData',
      meta: { titie: '任务数据' },
      component: TaskData,
    },
    {
      path: '/home/activity/record/userData',
      meta: { titie: '用户数据' },
      component: UserData,
    },
    {
      path: '/home/activity/record/statistics',
      meta: { titie: '数据统计' },
      component: Statistics,
    },
  ],
}
